import { useEffect } from 'react';
import { useParticipants } from '@livekit/components-react';
import { useAppDispatch } from '@/app/hooks';
import { setParticipantTrackPublications } from '@/features/live/liveSlice';

/**
 * Composant qui écoute les participants LiveKit et met à jour
 * l'état Redux avec les trackPublications par identité
 */
export default function ParticipantTrackPublicationsListener() {
  const participants = useParticipants();
  const dispatch = useAppDispatch();

  useEffect(() => {
    const trackPublicationsMap: Record<string, boolean> = {};

    participants.forEach((participant) => {
      // Vérifier si le participant a des trackPublications
      const hasTrackPublications = participant.trackPublications.size > 0;
      trackPublicationsMap[participant.identity] = hasTrackPublications;
    });

    dispatch(setParticipantTrackPublications(trackPublicationsMap));
  }, [participants, dispatch]);

  return null; // Ce composant ne rend rien
}
